import { render, staticRenderFns } from "./KontrolePredelava.vue?vue&type=template&id=7cd645c9&"
import script from "./KontrolePredelava.vue?vue&type=script&lang=js&"
export * from "./KontrolePredelava.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports